import React from 'react';

export interface ComponentErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ReactNode | ((error: Error, info: React.ErrorInfo | null) => React.ReactNode);
  onError?: (error: Error, info: React.ErrorInfo) => void;
}

interface ComponentErrorBoundaryState {
  error: Error | null;
  info: React.ErrorInfo | null;
}

export class ComponentErrorBoundary extends React.Component<ComponentErrorBoundaryProps, ComponentErrorBoundaryState> {
  state: ComponentErrorBoundaryState = { error: null, info: null };

  static getDerivedStateFromError(error: Error): ComponentErrorBoundaryState {
    return { error, info: null };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.props.onError?.(error, info);
    this.setState({ info });
  }

  render(): React.ReactNode {
    if (this.state.error) {
      const { fallback } = this.props;
      if (typeof fallback === 'function') {
        return fallback(this.state.error, this.state.info);
      }
      return fallback;
    }
    return this.props.children;
  }
}
